module.exports = __webpack_public_path__ + "img/content-with-img-links-mitsu.b66a8fca.jpg";